let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kvrhg")).then(() => parcelRequire('1Dpmk'));